import styled from "styled-components";

export const Photo = styled.div<{url:string}>`
    background-image: url(${({url}) => url?.match(/^\//) ? `https://api.joinrbn.com${url}` : url});
    background-size: cover;
    background-repeat: no-repeat;
    background-position: top center;
`;
